<!-- Row -->
<div class="md:flex surface-100 h-full relative overflow-hidden" aria-label="select-automation-event-popup" data-testid="select-automation-event-popup">
   <!-- <div class="surface-100 sticky top-0 left-0 py-3 pl-3 hidden md:block text-right z-1"><i class="fa fa-times text-xl text-600 cursor-pointer"></i>
  </div> -->
  <!-- Left Side - Sticky -->
  <div class="w-full md:w-4 lg:w-3 p-3 border-right-1 border-300 surface-0 md:sticky top-0 left-0 md:h-screen overflow-hidden">
      <!-- Updated search input using PrimeNG iconfield -->
      <p-iconfield iconPosition="left" class="mb-3">
          <p-inputicon styleClass="fa fa-search" />
          <input #searchInput type="text" class="text-sm w-full" pInputText [placeholder]="'common.PLACEHOLDER.SEARCH' | translate" (keyup)="SearchAutomation(searchInput.value)" [value]="searchInput.value" aria-label="automation-event-search-input" data-testid="automation-event-search-input" />
      </p-iconfield>

              <div class="overflow-y-auto" style="max-height: calc(80vh - 120px);">
            <ul class="text-xs md:text-sm list-none p-0 m-0 flex md:block white-space-nowrap md:white-space-normal overflow-x-auto md:overflow-x-visible w-full">
              <!-- Show skeleton when loading -->
              <ng-container *ngIf="loading">
                  <li *ngFor="let i of [1,2,3,4]" class="flex align-items-center md:mx-0 p-2 md:p-3 mr-1">
                      <p-skeleton width="150px" height="24px"></p-skeleton>
                  </li>
              </ng-container>

              <!-- Show actual content when not loading -->
              <ng-container *ngIf="!loading">
                  <li
                      *ngFor="let category of groupedAutomationMasters | automationFilter:search; let i = index"
                      [ngClass]="{'surface-100 md:surface-0 md:text-primary font-bold': selectedAutomationCategory === category.category_name, '': selectedAutomationCategory !== category.category_name}"
                      (click)="active1 = i"
                      class="flex align-items-center md:mx-0 p-2 md:p-3 mr-1 cursor-pointer hover:text-primary"
                      (click)="SelectCategory(category)"                      
                      [attr.aria-label]="'automation-category-'+category.category_name+'-button'"
                      [attr.data-testid]="'automation-category-'+category.category_name+'-button'"
                      >
                      <i [ngClass]="getCategoryData(category)?.icon + ' text-sm md:text-lg mr-2'"></i>
                      <span *ngIf="getCategoryData(category) as data">{{ 'AUTOMATION.CATEGORY.'+ category.category_name | translate }} ({{ category.count }})</span>
                  </li>
              </ng-container>
          </ul>
      </div>
  </div>
  <!-- Left Side -->

  <!-- Right Side - Scrollable -->
  <div class="w-full md:w-8 lg:w-9 flex-1 overflow-y-auto overflow-x-hidden" style="height: calc(80vh - 70px);">
      <!-- <div class="surface-100 sticky top-0 left-0 py-3 pl-3 hidden md:block text-right z-1"><i class="fa fa-times text-xl text-600 cursor-pointer"></i>
  </div> -->

      <!-- <h4 class="text-base md:text-lg font-normal mb-3 md:my-4">{{'AUTOMATION.CREATE.POPULAR_TRIGERS' | translate}}</h4> -->

      <!-- Grid -->
      <div class="px-3 pb-3">
          <div class="grid">
              <!-- Show skeleton cards when loading -->
              <ng-container *ngIf="loading">
                  <div class="col-12 md:col-6 xl:col-4" *ngFor="let i of [1,2,3,4,5,6]">
                      <div class="surface-0 border-round p-3 border-1 border-300">
                          <div class="flex md:block justify-content-between">
                              <div class="w-full">
                                  <p-skeleton width="80px" height="24px" styleClass="mb-2"></p-skeleton>
                                  <p-skeleton width="200px" height="20px" styleClass="mb-2"></p-skeleton>
                                  <p-skeleton width="150px" height="16px" styleClass="mb-2"></p-skeleton>
                                  <p-skeleton height="36px" styleClass="mb-2"></p-skeleton>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-container>

              <!-- Show actual cards when not loading -->
              <ng-container *ngIf="!loading" class="w-full">
                  <!-- Show filtered results -->
                  <div class="w-full" *ngFor="let category of groupedAutomationMasters | automationFilter:search; let i = index" #categorycontainer id="{{category.category_name}}">
                    <!-- Category Header with responsive styling -->
                    <div class="text-800 mt-4 mb-3 font-bold text-base md:text-lg border-bottom-1 surface-border pb-2" [attr.data-testid]="'automation-category-'+category.category_name+'-header'">
                      {{'AUTOMATION.CATEGORY.'+category.category_name | translate}}
                    </div>
                    <!-- Grid container -->
                    <div class="grid align-items-start">
                      <div class="col-12 md:col-6 xl:col-4 mb-3" 
                           *ngFor="let event of parseMap(category); let i = index">
                        <div [ngClass]="selectedAutomationEvent && selectedAutomationEvent.automation_type === event.automation_type ? 'shadow-3 border-2 text-primary border-primary' : 'border-1 border-300 shadow-1'"
                             class="surface-0 border-round p-3 h-full w-auto">
                          <div class="flex flex-column justify-content-between h-full">
                            <div>
                              <div class="mb-2">
                                <p-badge *ngIf="event.nature === 'Transactional'" severity="success" [value]="event.nature" styleClass="text-xxs lh-1 border-round" [attr.data-testid]="'automation-event-'+event.automation_type+'-transactional-badge'"></p-badge>
                                <p-badge *ngIf="event.nature === 'Promotional'" severity="success" [value]="event.nature" styleClass="text-xxs lh-1 border-round bg-pink-500" [attr.data-testid]="'automation-event-'+event.automation_type+'-promotional-badge'"></p-badge>
                              </div>
                              <h5 class="text-sm md:text-base mb-2" [attr.data-testid]="'automation-event-'+event.automation_type+'-title'">{{ 'AUTOMATION.EVENT.'+event.automation_type | translate }}</h5>
                              <p class="text-600 text-xs mb-3" [attr.data-testid]="'automation-event-'+event.automation_type+'-description'">{{event.description}}</p>
                            </div>
                            <div class="text-right">
                              <button
                                  [ngClass]="selectedAutomationEvent && selectedAutomationEvent.automation_type === event.automation_type ? 'p-outline-primary text-primary surface-0' : 'p-button-secondary'"
                                  (click)="SelectAutomationEvent(event)"
                                  class="p-ripple p-element text-sm p-button p-component py-1 line-height-3 hidden md:block"
                                  [attr.aria-label]="'select-automation-event-'+event.automation_type+'-button'"
                                  [attr.data-testid]="'select-automation-event-'+event.automation_type+'-button'">
                                <span class="fa fa-check-circle p-button-icon p-button-icon-left"></span>
                                <span class="p-button-label">{{ 'common.BUTTONS.BTN_SELECT' | translate }}</span>
                              </button>
                              <button
                                  [ngClass]="selectedAutomationEvent && selectedAutomationEvent.automation_type === event.automation_type ? 'p-outline-primary text-primary surface-0' : 'p-button-secondary'"
                                  (click)="SelectAutomationEvent(event)"
                                  class="p-ripple p-element text-sm p-button p-component p-button-icon-only md:hidden"
                                  [attr.aria-label]="'select-automation-event-'+event.automation_type+'-button-mobile'"
                                  [attr.data-testid]="'select-automation-event-'+event.automation_type+'-button-mobile'">
                                <span class="fa fa-check-circle p-button-icon"></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </ng-container>
          </div>
      </div>
      <!-- Grid -->
  </div>
  <!-- Right Side -->
</div>
<!-- Row -->

<!-- Modal Footer - Sticky -->
<div class="surface-0 fixed w-full left-0 bottom-0 z-1 p-3 border-top-1 border-300 flex align-items-center justify-content-between bg-white border-round-bottom">
  <p-button (click)="closePopup()" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-link text-sm" aria-label="cancel-automation-event-button" data-testid="cancel-automation-event-button"></p-button>
  <p-button [label]="'AUTOMATION.CREATE.BTN_SAVE_TRIGER'| translate " [disabled]="selectedAutomationEvent === null" [loading]="btnLoading" (click)="SaveData()" styleClass="text-sm" aria-label="save-automation-event-button" data-testid="save-automation-event-button"></p-button>
</div>
<!-- Modal Footer -->
